module.exports = __webpack_public_path__ + "img/fixappliances.ffc40a2c.png";